<template>
  <div class="base-organization-card">
    <BaseIcon name="briefcase" />
    <div class="base-organization-card__content">
      <div>
        {{ organization.name }}
      </div>
      <div v-if="organization.address">
        {{ organization.address.raw }}
      </div>
      <div v-if="organization.website">
        <BaseLink target-blank :href="organization.website">
          {{ organization.website }}
        </BaseLink>
      </div>
    </div>
  </div>
</template>

<script>
import BaseLink from '@/components/base/BaseLink';
import BaseIcon from '@/components/base/BaseIcon';

export default {
  name: 'BaseOrganizationCard',
  components: {
    BaseLink,
    BaseIcon,
  },
  props: {
    organization: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.base-organization-card {
  display: flex;
  gap: 16px;
  color: $color-normal;
  align-items: center;
  border-radius: $border-radius-medium;
  padding: 8px 16px;
  width: max-content;

  .base-icon {
    height: 16px;
    width: 16px;
    color: $color-normal-pale;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}
</style>
